import { isNetworkError } from './is-network-error'
import { unwrapDataWithResponseInit } from './data-with-response-init'

export type RetriableActionResult = {
  success: false
  retriable: true
  raw: unknown
}

// If `error` is a connectivity failure, return the benign marker the action-error middleware
// hands back to the client (in place of throwing to the error boundary). Otherwise null —
// non-network errors keep the existing generic ActionErrorDialog behavior. React Router wraps the
// real thrown value in a DataWithResponseInit, so unwrap before classifying (see
// ./data-with-response-init).
export function toRetriableActionResult(error: unknown): RetriableActionResult | null {
  if (!isNetworkError(unwrapDataWithResponseInit(error))) return null
  return { success: false, retriable: true, raw: error }
}

export function isRetriableActionResult(data: unknown): boolean {
  return (
    typeof data === 'object' && data !== null && 'retriable' in data && (data as { retriable?: unknown }).retriable === true
  )
}
